import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import React, { useEffect, useState, Component } from 'react';
import { provider, useInstance } from '@ekuaibao/react-ioc';
import { observer } from 'mobx-react';
import { Popconfirm, Checkbox, Radio } from 'antd';
import { T } from '@ekuaibao/i18n';
import { get } from 'lodash';
import { showMessage } from '@ekuaibao/show-util';
import { PermissionPopVM } from '../vms/PermissionPop.vm';
import { getPermissionOptions } from '../utils';
import styles from './permissionPop.module.less';
var CheckboxGroup = Checkbox.Group;
var PermissionPop = (function (_super) {
    __extends(PermissionPop, _super);
    function PermissionPop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PermissionPop.prototype.render = function () {
        return React.createElement(PermissionContent, __assign({}, this.props));
    };
    PermissionPop = __decorate([
        provider(PermissionPopVM),
        observer
    ], PermissionPop);
    return PermissionPop;
}(Component));
export default PermissionPop;
export function PermissionContent(props) {
    var _this = this;
    var vm = useInstance(PermissionPopVM);
    var getInitValue = function () {
        var _a;
        var initValue = [];
        (_a = props.value) === null || _a === void 0 ? void 0 : _a.forEach(function (v) {
            v.auth && initValue.push(v.name);
        });
        return initValue;
    };
    var _a = useState([]), value = _a[0], setValue = _a[1];
    var _b = useState([]), options = _b[0], setOptions = _b[1];
    useEffect(function () {
        var _a = (props.data || {}).model, model = _a === void 0 ? '' : _a;
        var options = getPermissionOptions(props.options, props.isRadio, model);
        setOptions(options);
    }, [props.options]);
    var onVisibleChange = function (visible) {
        var initValue = getInitValue();
        if (visible && JSON.stringify(initValue) !== JSON.stringify(value)) {
            setValue(initValue);
        }
    };
    var handleChange = function (checkedValues) {
        setValue(checkedValues);
    };
    var handleRadioChange = function (e) {
        setValue([e.target.value]);
    };
    var onConfirm = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var permissionValue, data, response, errMsg;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    permissionValue = [];
                    (_a = props.value) === null || _a === void 0 ? void 0 : _a.forEach(function (v) {
                        permissionValue.push({ name: v.name, auth: !!(value === null || value === void 0 ? void 0 : value.includes(v.name)) });
                    });
                    if (props.onConfirm) {
                        props.onConfirm(permissionValue);
                        return [2];
                    }
                    data = __assign({ permissions: permissionValue }, props.data);
                    return [4, vm.savePermission(__assign({}, data))];
                case 1:
                    response = _f.sent();
                    (_b = props.onConfirmFinish) === null || _b === void 0 ? void 0 : _b.call(props);
                    if ((_c = response === null || response === void 0 ? void 0 : response.meta) === null || _c === void 0 ? void 0 : _c.value) {
                        showMessage.success(i18n.get('修改成功'));
                        (_d = props.onConfirmSuccess) === null || _d === void 0 ? void 0 : _d.call(props, permissionValue);
                    }
                    else {
                        errMsg = get(response, 'error.errorMessage') ||
                            get(response, 'error.message') ||
                            i18n.get('修改失败');
                        showMessage.error(errMsg);
                        (_e = props.onConfirmError) === null || _e === void 0 ? void 0 : _e.call(props);
                    }
                    return [2];
            }
        });
    }); };
    var renderTitle = function () {
        return React.createElement(Title, { title: props.title, options: options, value: value, onChange: handleChange });
    };
    var renderRadioTitle = function () {
        var radioValue = (value === null || value === void 0 ? void 0 : value.length) ? value[0] : '';
        return (React.createElement(TitleRadio, { title: props.title, options: options, value: radioValue, onChange: handleRadioChange }));
    };
    var getPopupContainer = props.getPopupContainer ? props.getPopupContainer : function () { return document.body; };
    return (React.createElement(Popconfirm, { key: props.key, overlayClassName: styles['permission-pop-wrapper'] + " " + (props.isRadio ? styles['permission-pop-radio-wrapper'] : ''), placement: props.placement || 'bottom', trigger: props.trigger || 'click', title: props.isRadio ? renderRadioTitle() : renderTitle(), getPopupContainer: getPopupContainer, onConfirm: function () { return onConfirm(value); }, onVisibleChange: onVisibleChange, okText: props.okText || React.createElement(T, { name: "\u786E\u5B9A" }), cancelText: props.cancelText || React.createElement(T, { name: "\u53D6\u6D88" }) }, props.children));
}
function Title(props) {
    return (React.createElement("div", { className: "permission-title-popover", onClick: function (e) { return e.stopPropagation(); } },
        React.createElement("div", { className: "permission-title" }, i18n.get(props === null || props === void 0 ? void 0 : props.title)),
        React.createElement(CheckboxGroup, { className: "permission-group", options: props.options || [], value: props.value, onChange: props.onChange })));
}
function TitleRadio(props) {
    return (React.createElement("div", { className: "permission-title-radio-wrapper" },
        React.createElement("div", { className: "title" }, React.createElement(T, { name: props.title })),
        React.createElement("div", { className: "line" }),
        React.createElement("div", { className: "content" },
            React.createElement(Radio.Group, { value: props.value, onChange: props.onChange }, props.options.map(function (oo) { return (React.createElement("div", { key: oo.value },
                React.createElement(Radio, { className: "check-item", value: oo.value }, React.createElement(T, { name: oo.name })),
                React.createElement("br", null))); })))));
}
